import { microfrontends, resolveMicrofrontendPath } from '@/common/config/microfrontends.config.js'
import { resolveLegacyMenuUrl } from './legacy-menu-url.js'

/**
 * Ruta interna del shell que monta el microfrontend de Nómina.
 * Nómina no define `resolvedPath`, así que `resolveMicrofrontendPath` devuelve `${basePath}${defaultPath}`.
 */
const RUTA_NOMINA =
  microfrontends.nomina.resolvedPath ?? `${microfrontends.nomina.basePath}${microfrontends.nomina.defaultPath}`

/**
 * Indica si una URL del menú corresponde al acceso a Nómina.
 *
 * El nodo del menú llega desde el backend, así que puede venir con la ruta visible actual
 * (`/nomina`) o con alguno de los alias legacy (`/nomina-trabajadores`, `/trabajadores/nomina`).
 *
 * @param {string|undefined|null} url URL cruda del nodo de menú.
 * @returns {boolean}
 */
export function isNominaMenuUrl(url) {
  if (!url) return false

  return resolveMicrofrontendPath(url) === RUTA_NOMINA
}

/**
 * Destino del acceso a Nómina: ítem del menú principal y botón de validación de nómina que el
 * remote de Credenciales dispara vía `onNavigateToNomina`.
 *
 * Nómina no se despliega en todos los ambientes. Mientras un ambiente siga usando la pantalla del
 * PHP legacy, define `VITE_LEGACY_NOMINA_URL` con esa URL (build-time) y se resuelve esa URL; si la
 * variable no está definida, si el pipeline entrega el macro sin expandir o si el valor no es una
 * URL absoluta, se devuelve `fallbackRoute` (el comportamiento previo al fix).
 *
 * @param {string} fallbackRoute Destino a usar cuando no hay URL legacy válida.
 * @returns {string} URL absoluta del PHP legacy, o el fallback.
 */
export function resolveNominaUrl(fallbackRoute) {
  return resolveLegacyMenuUrl(import.meta.env.VITE_LEGACY_NOMINA_URL, fallbackRoute)
}
